import ko from 'knockout';

export class OptionsSectionViewModel {
  constructor({ i18n, observable }) {
    this.observable = observable;
    this.showAdvancedOptions = ko.observable(false);
    this.hideText = i18n.getString('Import_ImportOptions_HideAdvancedOptions');
    this.showText = i18n.getString('Import_ImportOptions_ShowAdvancedOptions');

    this.displayWarningMessage = ko.observable(false);
  }
}
